
























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import baseSpinner from '@/components/Spinner';
import CustomImage from '@/components/Globals/CustomImage.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

const swiperOptions = {
  slidesPerView: 4.5,
  slidesPerGroup: 1,
  loop: false,
  loopedSlides: 0,
  speed: 300,
  freeMode: true,
  freeModeMomentum: true,
  freeModeMomentumRatio: 0.9,
  breakpoints: {
    375: {
      slidesPerView: 5.5,
    },
    768: {
      slidesPerView: 7,
      freeModeMomentumRatio: 0.75,
    },
  },
  shortSwipes: false,
  watchSlidesProgress: true,
  watchSlidesVisibility: true
};

@Component({
  components: {
    CustomContainer,
    baseSpinner,
    CustomImage,
    Swiper,
    SwiperSlide
  }
})
export default class PatternMakerStickersCarousel extends Vue {
  enableCarouselNavigation = true;
  enableSwiper = false;
  isClicked = false;
  currentStickerActiveIndex : Number = -1
  swiperOptions = {
    ...swiperOptions,
    navigation: {
      prevEl: '.patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-previous.stickers',
      nextEl: '.patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-next.stickers'
    }
  }

  @Prop({default: () => []})
  stickers!: any[];

  @Prop({default: false})
  enabled!: boolean;

  @Prop({default: false})
  slideToSelectedItem!: boolean;

  @Prop()
  currentSticker!: String | Number;

  @Watch('stickers')
  public watchStickers (){
    this.checkEnableCarouselNavigation();
  }

  get swiper() {
    return (this.$refs as any).swiper.$swiper;
  }

  get enableStickerGroups() {
    return this.$store.state.utils.configuration.enableStickerGroups;
  }

  checkEnableLoop() {
    let enableLoop;
    const viewportWidth = window.innerWidth;
    const breakpoints = this.swiperOptions.breakpoints ? Object.keys(this.swiperOptions.breakpoints).sort((a, b) => Number(a)-Number(b)) : [];
    if (!breakpoints.length || viewportWidth < Number(breakpoints[0])) {
      enableLoop = this.stickers.length > this.swiperOptions.slidesPerView;
    }
    for (let i = 0; i < breakpoints.length - 1 && !enableLoop; i++) {
      if (viewportWidth >= Number(breakpoints[i]) && viewportWidth < Number(breakpoints[i + 1])) {
        enableLoop = this.stickers.length > (this as any).swiperOptions.breakpoints[breakpoints[i]].slidesPerView;
      }
    }
    if (!enableLoop && breakpoints.length && viewportWidth >= Number(breakpoints[breakpoints.length - 1])) {
      enableLoop = this.stickers.length > (this as any).swiperOptions.breakpoints[breakpoints[breakpoints.length - 1]].slidesPerView;
    }
    return enableLoop;
  }

  checkEnableCarouselNavigation() {
    if (this.stickers && !this.stickers.length) return;
    const viewportWidth = window.innerWidth;
    const enableLoop = this.checkEnableLoop();
    if (this.swiperOptions.loop !== enableLoop) (this as any).swiperOptions.loop = enableLoop;
    if (enableLoop && (this.swiperOptions.loopedSlides !== this.stickers.length)) this.swiperOptions.loopedSlides = this.stickers.length;
    (this as any).enableCarouselNavigation = enableLoop && viewportWidth >= 768;
    this.enableSwiper = !!this.stickers.length;
  }

  stickerTouched(event: any) {
    if (this.isClicked || !this.enabled) return;
      this.isClicked = true;
      const diff = this.swiper.touches.startX - this.swiper.touches.currentX;
      if (diff >= -1 && diff <= 1) {
        this.stickerClicked(event);
      }
      this.isClicked = false;
  }

  stickerClicked(e: any) {
    let eventAction = 'pattern maker';
    const id = e.target.getAttribute('data-sticker-id');
    const groupName = e.target.getAttribute('data-sticker-group-name');
    let sticker;
    if (groupName) {
      sticker = this.stickers.find(sticker => Number(sticker.id) === Number(id) && sticker.originalGroup === groupName);
    } else {
      sticker = this.stickers.find(sticker => Number(sticker.id) === Number(id));
    }
    if (this.$store.getters['utils/useEcomDataLayerFormat']) {
      (this as any).$patternMakerDatalayer.logAnalyticsEvent({action: 'Select Pattern Sticker', eventLabel: sticker.id});
    }
    if (this.enableStickerGroups) {
      const stickerIndex = this.stickers.indexOf(sticker);
      this.updateStickerTabComponent(sticker, stickerIndex);
    }

    this.$emit('sticker-selected', sticker);

    if (this.$store.getters['patternMaker/isSecondComponentFlow']) {
      eventAction += ' - second component';
    }
  }

  goToSticker({ groupName = '', stickerIndex = null, moveToFirstStickerOfGroup = false }) {
      if (!this.swiperOptions.loop || !moveToFirstStickerOfGroup) return;
      let originalArrayIndex;
      if (stickerIndex !== null) {
        originalArrayIndex = stickerIndex;
      } else {
        // find the first sticker of the group
        const firstStickerIndex = this.stickers.findIndex(sticker => sticker.originalGroup === groupName);
        if (firstStickerIndex !== -1) {
          originalArrayIndex = firstStickerIndex;
        }
      }

      const activeIndex = this.swiper.activeIndex;

      const totalOriginalElements = this.stickers.length;
      const totalLoopedSlides = this.swiper.loopedSlides || 0;
      let lowerPosition = originalArrayIndex + totalLoopedSlides - totalOriginalElements;
      let upperPosition = originalArrayIndex + totalLoopedSlides;
      if (lowerPosition < 0) { // advance to next 'window'
        lowerPosition += totalOriginalElements;
        upperPosition += totalOriginalElements;
      }
      const distanceToLowerPosition = Math.abs(activeIndex - lowerPosition);
      const distanceToUpperPosition = Math.abs(activeIndex - upperPosition);
      let position;
      // finds the closest position
      if (distanceToLowerPosition < distanceToUpperPosition && lowerPosition >= 0) {
        position = lowerPosition;
      } else {
        position = upperPosition;
      }
      // first try to use prev/next to avoid the jump caused by a sequence of calls to slideTo
      if (position === activeIndex - 1) {
        this.swiper.slidePrev();
      } else if (position === activeIndex + 1) {
        this.swiper.slideNext();
      } else {
        const slidedWithSuccess = this.swiper.slideTo(position, this.swiperOptions.speed, false);
        if (!slidedWithSuccess && position !== activeIndex) { // go back one 'window'
          position -= totalOriginalElements;
          this.swiper.slideTo(position, this.swiperOptions.speed, false);
        }
      }
      this.currentStickerActiveIndex = position;
  }

  stickerSlideChanged() {
    if (!this.enableStickerGroups || !this.swiperOptions.loop) {
      return;
    }

    const { realIndex, activeIndex } = this.swiper;
    const sticker = this.stickers[realIndex];

    if (this.currentStickerActiveIndex !== activeIndex && sticker) {
      const group = this.getStickerGroup(sticker, false);
      this.$eventBus.$emit('sticker-tab-selected', group);
      this.currentStickerActiveIndex = activeIndex;
    }
  }

  getStickerGroup({ alternativeGroup = null, originalGroup= '' }, getAlternativeGroup : any){
    return alternativeGroup && getAlternativeGroup ? alternativeGroup : originalGroup;
  }

  moveCurrentStickerIntoView() {
    const currentSticker = this.currentSticker ? this.stickers.find(sticker => sticker.id === this.currentSticker && sticker.originalGroup !== 'new') : null;
    const currentStickerIndex = this.stickers.indexOf(currentSticker);
    if (currentStickerIndex < 0) return;
    else this.$nextTick(() => {
      this.swiper.slideToLoop(currentStickerIndex);
      if (this.enableStickerGroups) this.updateStickerTabComponent(currentSticker, currentStickerIndex);
    });
  }

  updateStickerTabComponent(currentSticker : any, currentStickerIndex : any) {
    const groupName = this.getStickerGroup(currentSticker, true);
    this.$eventBus.$emit('sticker-tab-selected', groupName);
    // @ts-ignore
    this.goToSticker({ groupName: groupName, stickerIndex: currentStickerIndex, moveToFirstStickerOfGroup: this.slideToSelectedItem });
  }

  created() {
    this.checkEnableCarouselNavigation();
    this.$eventBus.$on('patternmaker-go-to-sticker', this.goToSticker);
    this.$eventBus.$on('patternmaker-move-current-sticker-into-view', this.moveCurrentStickerIntoView);
    window.addEventListener('resize', this.checkEnableCarouselNavigation);
  }

  mounted() {
    if (this.stickers.length && this.currentSticker && this.slideToSelectedItem) this.moveCurrentStickerIntoView();
  }

  beforeDestroy() {
    this.$eventBus.$off('patternmaker-go-to-sticker', this.goToSticker);
    this.$eventBus.$off('patternmaker-move-current-sticker-into-view', this.moveCurrentStickerIntoView);
    window.removeEventListener('resize', this.checkEnableCarouselNavigation);
  }
}
